import { SVGProps } from 'react';

const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 33 32" {...props}>
    <path
      stroke="#28C156"
      strokeLinecap="round"
      strokeWidth={2}
      d="M23.333 12c2.9.016 4.47.145 5.495 1.17C30 14.34 30 16.225 30 19.997v1.333c0 3.771 0 5.657-1.172 6.828S25.771 29.331 22 29.331H11.333c-3.77 0-5.657 0-6.828-1.172s-1.172-3.057-1.172-6.828v-1.333c0-3.772 0-5.657 1.172-6.829C5.529 12.145 7.1 12.016 10 12"
    />
    <path
      stroke="#28C156"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.667 2.668v17.333m0 0-4-4.666m4 4.666 4-4.666"
    />
  </svg>
);

export default SvgDownload;
